import Snackbar from '@mui/material/Snackbar'
import CircularProgress from '@mui/material/CircularProgress'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { ErrorContainer, SuccessContainer } from './styled'
import { useEffect, useState } from 'react'
import { RenderIf } from 'shared/helpers/renderIf'
import { useLoadingStore } from 'shared/store/toasterSlice'
import { Alert } from '@mui/material'

export const Toaster = () => {
  const { isLoading, isSuccess, isError, errorMessage, resetLoading } = useLoadingStore()

  useEffect(() => {
    let timer: any
    if (isSuccess || isError) {
      timer = setTimeout(resetLoading, errorMessage ? 5000 : 1500)
    }
    return () => {
      clearTimeout(timer)
    }
  }, [isSuccess, isError])

  return (
    <>
      <Snackbar
        open={true}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        message='test'
      >
        <div>
          <RenderIf condition={isSuccess}>
            <SuccessContainer>
              <CheckIcon />
            </SuccessContainer>
          </RenderIf>
          <RenderIf condition={isError && !errorMessage}>
            <ErrorContainer>
              <CloseIcon />
            </ErrorContainer>
          </RenderIf>
          <RenderIf condition={isLoading}>
            <CircularProgress />
          </RenderIf>
          {/* TODO: render with error message only */}
          <RenderIf condition={isError && !!errorMessage}>
            <Alert onClose={resetLoading} severity='error' variant='filled'>
              {errorMessage}
            </Alert>
          </RenderIf>
        </div>
      </Snackbar>
    </>
  )
}
